var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-sections',{staticClass:"invitations-form",attrs:{"schema":_vm.schema,"buttonless":""},on:{"change":_vm.change,"paste":_vm.paste}})}
var staticRenderFns = []

export { render, staticRenderFns }